// extracted by mini-css-extract-plugin
export default {"transparent":"LoggedIn_transparent__fDhmO"};